import { render } from "./Rest.vue?vue&type=template&id=35eef878&scoped=true"
import script from "./Rest.vue?vue&type=script&lang=js"
export * from "./Rest.vue?vue&type=script&lang=js"

import "./Rest.vue?vue&type=style&index=0&id=35eef878&lang=css"
import "./Rest.vue?vue&type=style&index=1&id=35eef878&scoped=true&lang=css"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35eef878"]])

export default __exports__